/* EDG Martingale QA hardening — protects fit-state and published lower bounds. */
(function () {
  'use strict';

  function guided() {
    return new URLSearchParams(window.location.search || '').get('edg_guided') === '1';
  }

  function parseRange(label) {
    var match = String(label || '').match(/([0-9]+(?:\.[0-9]+)?)\s*[-–]\s*([0-9]+(?:\.[0-9]+)?)/);
    return match ? { min: Number(match[1]), max: Number(match[2]) } : null;
  }

  function publishedBounds(root) {
    var ranges = Array.from(root.querySelectorAll('[data-size-choice]'))
      .map(function (button) { return parseRange(button.dataset.nativeValue || ''); })
      .filter(Boolean);
    if (!ranges.length) return null;
    return {
      min: Math.min.apply(null, ranges.map(function (range) { return range.min; })),
      max: Math.max.apply(null, ranges.map(function (range) { return range.max; }))
    };
  }

  function pretty(value) {
    return Number(Number(value).toFixed(3)).toString();
  }

  function setStep(root, key, state) {
    var step = root.querySelector('[data-step="' + key + '"]');
    if (!step) return;
    step.classList.remove('is-active', 'is-complete', 'is-locked');
    step.classList.add('is-' + state);
    var header = step.querySelector('[data-edit-step]');
    if (header) {
      header.disabled = state === 'locked';
      header.setAttribute('aria-expanded', state === 'active' ? 'true' : 'false');
    }
    var progress = root.querySelector('[data-progress="' + key + '"]');
    if (progress) {
      progress.classList.toggle('is-active', state === 'active');
      progress.classList.toggle('is-complete', state === 'complete');
    }
  }

  function setSummary(root, key, text) {
    var node = root.querySelector('[data-step-summary="' + key + '"]');
    if (node) node.textContent = text;
  }

  function clearSelected(root, selector) {
    Array.from(root.querySelectorAll(selector)).forEach(function (button) {
      button.classList.remove('is-selected');
      if (button.hasAttribute('aria-pressed')) button.setAttribute('aria-pressed', 'false');
    });
  }

  function resetStandardDownstream(root) {
    root.dataset.sizeValue = '';
    root.dataset.webbingWidth = '';
    root.dataset.colorValue = '';
    clearSelected(root, '[data-size-choice], [data-width-choice]');
    var color = root.querySelector('[data-color-select]');
    if (color) color.value = '';

    setSummary(root, 'fit', 'Neck + widest head, then closure');
    setSummary(root, 'width', 'Physical webbing width');
    setSummary(root, 'color', 'Only compatible colors');
    setSummary(root, 'review', 'Confirm the guided build');

    setStep(root, 'fit', 'active');
    setStep(root, 'width', 'locked');
    setStep(root, 'color', 'locked');
    setStep(root, 'addons', 'locked');
    setStep(root, 'review', 'locked');

    ['fit', 'closure', 'size', 'width', 'color'].forEach(function (key) {
      var node = root.querySelector('[data-review-' + key + ']');
      if (node) node.textContent = '';
    });

    var session = window.EDGBuildSession;
    if (session && session.saveBuild) {
      var neckField = root.querySelector('[data-neck]');
      var headField = root.querySelector('[data-head]');
      var neck = neckField ? Number(neckField.value) : 0;
      var head = headField ? Number(headField.value) : 0;
      var closure = root.dataset.closure || '';
      var governing = closure === 'buckle' ? neck : Math.max(neck || 0, head || 0);
      session.saveBuild('martingale', {
        mode: 'standard',
        productHandle: root.dataset.productHandle || 'martingale-collar',
        neck: neck > 0 ? pretty(neck) : '',
        head: head > 0 ? pretty(head) : '',
        closure: closure,
        sizingBasis: closure === 'buckle' ? 'neck' : (closure ? 'larger of neck/head' : ''),
        governingMeasurement: governing > 0 ? pretty(governing) : '',
        size: '',
        webbingWidth: '',
        color: '',
        guided: guided()
      });
    }
  }

  function correctStandardLowerBound(root) {
    if (root.dataset.edgSizingMode === 'known') return;
    var neckField = root.querySelector('[data-neck]');
    var headField = root.querySelector('[data-head]');
    var neck = neckField ? Number(neckField.value) : 0;
    var head = headField ? Number(headField.value) : 0;
    var closure = root.dataset.closure || '';
    if (!(neck > 0 && head > 0 && closure)) return;

    var bounds = publishedBounds(root);
    if (!bounds) return;
    var required = closure === 'buckle' ? neck : Math.max(neck, head);
    if (!(required < bounds.min)) return;

    Array.from(root.querySelectorAll('[data-size-choice]')).forEach(function (button) {
      button.hidden = true;
      button.classList.remove('is-selected');
    });
    root.dataset.sizeValue = '';

    var area = root.querySelector('[data-size-result]');
    if (area) area.hidden = false;
    var label = root.querySelector('[data-size-result-label]');
    if (label) label.textContent = 'Below published size range';
    var measure = root.querySelector('[data-governing-measurement]');
    if (measure) measure.textContent = pretty(required) + ' in';
    var note = root.querySelector('[data-size-result-note]');
    if (note) {
      note.textContent = closure === 'buckle'
        ? 'This neck measurement is below the smallest published Martingale size (' + pretty(bounds.min) + ' in). Double-check the measurement before continuing. If it is correct, contact EDG for sizing help.'
        : 'This required opening is below the smallest published Martingale size (' + pretty(bounds.min) + ' in). Double-check both measurements before continuing. If they are correct, contact EDG for sizing help.';
    }
  }

  function resetFiDownstream(root) {
    root.dataset.sizeValue = '';
    root.dataset.colorValue = '';
    clearSelected(root, '[data-size-choice]');
    var color = root.querySelector('[data-color-select]');
    if (color) color.value = '';

    setSummary(root, 'fit', 'Neck + widest head required');
    setSummary(root, 'color', 'Aesthetic choice comes after fit + compatibility');
    setSummary(root, 'finish', 'Optional upgrades only');

    setStep(root, 'fit', 'active');
    setStep(root, 'fi', 'locked');
    setStep(root, 'color', 'locked');
    setStep(root, 'finish', 'locked');

    var review = root.querySelector('[data-review]');
    if (review) review.hidden = true;
    ['fit', 'size', 'color'].forEach(function (key) {
      var node = root.querySelector('[data-review-' + key + ']');
      if (node) node.textContent = '';
    });
  }

  function correctFiLowerBound(root) {
    var neckField = root.querySelector('[data-neck]');
    var headField = root.querySelector('[data-head]');
    var neck = neckField ? Number(neckField.value) : 0;
    var head = headField ? Number(headField.value) : 0;
    if (!(neck > 0 && head > 0)) return;

    var bounds = publishedBounds(root);
    if (!bounds) return;
    var required = Math.max(neck, head);
    if (!(required < bounds.min)) return;

    Array.from(root.querySelectorAll('[data-size-choice]')).forEach(function (button) {
      button.hidden = true;
      button.classList.remove('is-selected');
    });
    root.dataset.sizeValue = '';

    var area = root.querySelector('[data-size-results]');
    if (area) area.hidden = false;
    var question = area && area.querySelector('.edg-guide__question');
    if (question) question.textContent = 'Below published size range';
    var note = root.querySelector('[data-size-note]');
    if (note) {
      note.textContent = 'This required opening is below the smallest published Fi Martingale size (' + pretty(bounds.min) + ' in). Double-check both measurements before continuing. If they are correct, contact EDG for sizing help.';
    }
  }

  function afterStandardFitChange(root) {
    if (root.dataset.edgSizingMode === 'known') return;
    window.setTimeout(function () {
      if (root.dataset.edgSizingMode === 'known') return;
      resetStandardDownstream(root);
      var core = window.EDGStandardMartingaleCore;
      if (core && core.updateFit) core.updateFit(root, window.EDGBuildSession);
      correctStandardLowerBound(root);
    }, 0);
  }

  function afterFiFitChange(root) {
    window.setTimeout(function () {
      resetFiDownstream(root);
      correctFiLowerBound(root);
    }, 40);
  }

  function initStandard(root) {
    if (!root || root.dataset.edgMartingaleQa === 'true' || !guided()) return;
    root.dataset.edgMartingaleQa = 'true';
    Array.from(root.querySelectorAll('[data-neck], [data-head]')).forEach(function (field) {
      field.addEventListener('input', function () { afterStandardFitChange(root); });
      field.addEventListener('change', function () { afterStandardFitChange(root); });
    });
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-closure-choice]')) afterStandardFitChange(root);
    });
    window.setTimeout(function () { correctStandardLowerBound(root); }, 260);
  }

  function initFi(root) {
    if (!root || root.dataset.edgMartingaleQa === 'true' || !guided()) return;
    if ((root.dataset.productHandle || '') !== 'fi-martingale-collar' && window.location.pathname.indexOf('/products/fi-martingale-collar') < 0) return;
    root.dataset.edgMartingaleQa = 'true';
    Array.from(root.querySelectorAll('[data-neck], [data-head]')).forEach(function (field) {
      field.addEventListener('input', function () { afterFiFitChange(root); });
      field.addEventListener('change', function () { afterFiFitChange(root); });
    });
    window.setTimeout(function () { correctFiLowerBound(root); }, 320);
  }

  function boot(scope) {
    var base = scope || document;
    initStandard(base.querySelector ? base.querySelector('[data-edg-standard-martingale-builder]') : null);
    var fiRoot = base.querySelector ? base.querySelector('[data-edg-guide][data-product-handle="fi-martingale-collar"]') : null;
    if (!fiRoot) fiRoot = document.querySelector('[data-edg-guide][data-product-handle="fi-martingale-collar"]');
    initFi(fiRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();


